module.exports = __webpack_public_path__ + "img/kn.73d53434.png";